module.exports = __webpack_public_path__ + "static/media/KNET_Gray.ece0409b.webp";